import { Organization } from "chq";

import { CreatomateFont } from "../fonts/BuiltInFonts";
import { CreatomateVerizonFonts } from "../fonts/VerizonFonts";
import { CreatomateMerckFonts } from "../fonts/MerckFonts";
import { CreatomateIntuitiveFonts } from "../fonts/IntuitiveFonts";
import { CreatomateZendeskFonts } from "../fonts/ZendeskFonts";
import { CreatomateMicrosoftFonts } from "../fonts/MicrosoftFonts";
import { CreatomateSantanderFonts } from "../fonts/SantanderFonts";
import { CreatomatePremiseHealthFonts } from "../fonts/PremiseHealthFonts";
import { CreatomateInternationalRescueCommitteeFonts } from "../fonts/InternationalRescueCommitteeFonts";
import { CreatomateComcastFonts } from "../fonts/ComcastFonts";
import { CreatomateRTXFonts } from "../fonts/RTXFonts";
import { CreatomateTargetFonts } from "../fonts/TargetFonts";

const loadOrganizationFonts = (
  organization: Organization
): CreatomateFont[] => {
  let fonts: CreatomateFont[] = [];
  switch (organization?.name) {
    case "Merck":
    case "MSD":
      fonts = CreatomateMerckFonts;
      break;
    case "Microsoft":
      fonts = CreatomateMicrosoftFonts;
      break;
    case "Intuitive":
      fonts = CreatomateIntuitiveFonts;
      break;
    case "Premise Health":
      fonts = CreatomatePremiseHealthFonts;
      break;
    case "Santander":
    case "Santander Private Space":
      fonts = CreatomateSantanderFonts;
      break;
    case "Verizon":
      fonts = CreatomateVerizonFonts;
      break;
    case "Zendesk":
    case "Zendesk Working Space":
      fonts = CreatomateZendeskFonts;
      break;
    case "International Rescue Committee":
      fonts = CreatomateInternationalRescueCommitteeFonts;
      break;
    case "Comcast":
      fonts = CreatomateComcastFonts;
      break;
    case "RTX":
      fonts = CreatomateRTXFonts;
      break;
    case "Target":
      fonts = CreatomateTargetFonts;
      break;
    default:
      break;
  }

  return fonts;
};

export default loadOrganizationFonts;
